import React, { useEffect } from 'react';
import styles from './NetworkUI.module.css';

const Node = ({ imageUrl, fullName, domain, description, onClick }) => (
  <div className={styles.node} onClick={onClick}>
    <img src={imageUrl} alt={fullName} className={styles.nodeImage} />
    <div className={styles.nodeInfo}>
      <h4>{fullName}</h4>
      <p>{domain}</p>
      <p className={styles.description}>{description}</p>
    </div>
  </div>
);

const NetworkUI = ({ selectedAgent, setSelectedAgent }) => {
  const nodes = [
    {
      agentId: 1,
      imageUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&crop=faces&w=500&h=500',
      fullName: 'Sarah Johnson',
      gender: 'Female',
      domain: 'Real Estate Specialist',
      description: 'Guides clients through property buying and selling with ease.',
    },
    {
      agentId: 2,
      imageUrl: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?ixlib=rb-4.0.3&crop=faces&w=500&h=500',
      fullName: 'Rohit Singh',
      gender: 'Male',
      domain: 'Lead Generation Expert',
      description: 'Drives high-quality leads with targeted outreach strategies.',
    },
    {
      agentId: 3,
      imageUrl: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-4.0.3&crop=faces&w=500&h=500',
      fullName: 'Aileen Kim',
      gender: 'Female',
      domain: 'Hospital Receptionist',
      description: 'Manages patient appointments and inquiries with care.',
    },
    {
      agentId: 4,
      imageUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&crop=faces&w=500&h=500',
      fullName: 'David Lopez',
      gender: 'Male',
      domain: 'AI Calling Assistant',
      description: 'Automates customer outreach with natural, AI-driven calls.',
    },
    {
      agentId: 5,
      imageUrl: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?ixlib=rb-4.0.3&crop=faces&w=500&h=500',
      fullName: 'Priya Desai',
      gender: 'Female',
      domain: 'AI Calling Support',
      description: 'Enhances call efficiency with AI-powered response handling.',
    },
  ];

  // Set first agent as default on mount if none is selected and nodes array is not empty
  useEffect(() => {
    if (!selectedAgent && nodes.length > 0) {
      setSelectedAgent(nodes[0]); // Select Sarah Johnson by default
    }
  }, []); // Empty dependency array for mount-only execution

  return (
    <div className={styles.networkContainer}>
      <div className={styles.outerCircle}>
        <div className={styles.middleCircle}>
          <div className={styles.innerCircle}></div>
        </div>
        {nodes.map((node) => (
          <Node
            key={node.agentId} // Use agentId for unique key
            {...node}
            onClick={() => setSelectedAgent(node)}
          />
        ))}
      </div>
    </div>
  );
};

export default NetworkUI;